import { render, staticRenderFns } from "./GoBack.vue?vue&type=template&id=0172d255&scoped=true"
import script from "./GoBack.vue?vue&type=script&lang=js"
export * from "./GoBack.vue?vue&type=script&lang=js"
import style0 from "./GoBack.vue?vue&type=style&index=0&id=0172d255&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0172d255",
  null
  
)

export default component.exports